export const SuccessIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 24C10.34 24 8.78 23.6848 7.32 23.0544C5.86 22.424 4.59 21.5692 3.51 20.49C2.43 19.41 1.5752 18.14 0.9456 16.68C0.316 15.22 0.0008 13.66 0 12C0 10.34 0.3152 8.78 0.9456 7.32C1.576 5.86 2.4308 4.59 3.51 3.51C4.59 2.43 5.86 1.5752 7.32 0.9456C8.78 0.316 10.34 0.0008 12 0C13.66 0 15.22 0.3152 16.68 0.9456C18.14 1.576 19.41 2.4308 20.49 3.51C21.57 4.59 22.4252 5.86 23.0556 7.32C23.686 8.78 24.0008 10.34 24 12C24 13.66 23.6848 15.22 23.0544 16.68C22.424 18.14 21.5692 19.41 20.49 20.49C19.41 21.57 18.14 22.4252 16.68 23.0556C15.22 23.686 13.66 24.0008 12 24ZM12 22C14.68 22 17.14 20.86 19 19C20.86 17.14 22 14.68 22 12C22 9.32 20.86 6.86 19 5C17.14 3.14 14.68 2 12 2C9.32 2 6.86 3.14 5 5C3.14 6.86 2 9.32 2 12C2 14.68 3.14 17.14 5 19C6.86 20.86 9.32 22 12 22Z"
        fill="#33C341"
      />
      <path
        d="M11 16L18 8"
        stroke="#33C341"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M11 16L6.5 11.5"
        stroke="#33C341"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  )
}
